import { useQuery } from '@tanstack/react-query';
import type { GetWidgetChatRequest, GetWidgetChatResponse } from 'server';
import { appFetch } from './appFetch';
import { widgetKeys } from './keys';

export const useGetChat = (chatId: string, organizationId: string, agentId: string) => {
  return useQuery({
    queryKey: widgetKeys.chat(chatId),
    queryFn: async (): Promise<GetWidgetChatResponse> => {
      const request: GetWidgetChatRequest = {
        organizationId,
        agentId,
        chatId
      };
      const response = await appFetch<GetWidgetChatResponse>(`/app/public/widget/chats/${chatId}`, {
        method: 'POST',
        body: request
      });
      return response;
    },
    enabled: !!chatId && !!organizationId && !!agentId
  });
};
